import axios from '../../services/api.service';

export const customerGetAll = async () => {
  try {
    const { data: response } = await axios.get('/review-1/customers');
    return response.items;
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const customerPostOne = async (data: object) => {
  try {
    await axios.post('/review-1/customers', data);
    return 'success';
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const customerGetOne = async (elementId: string) => {
  try {
    const { data: response } = await axios.get(`/review-1/customers/${elementId}`);
    return response.item;
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const customerPutOne = async (elementId: string, data: object) => {
  try {
    await axios.put(`/review-1/customers/${elementId}`, data);
    return 'success';
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const customerDeleteOne = async (elementId: string) => {
  try {
    await axios.delete(`/review-1/customers/${elementId}`);
    return 'success';
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const customerGetOnePND = async (elementId: string) => {
  try {
    const { data: response } = await axios.get(`/review-1/customers/${elementId}/pnd`);
    return response.item;
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const customerPutOnePND = async (elementId: string, data: object) => {
  try {
    await axios.put(`/review-1/customers/${elementId}/pnd`, data);
    return 'success';
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const customerGetOneBenchmarking = async (elementId: string) => {
  try {
    const { data: response } = await axios.get(`/review-1/customers/${elementId}/benchmarking`);
    return response.item;
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const customerPutOneBenchmarking = async (elementId: string, data: object) => {
  try {
    await axios.put(`/review-1/customers/${elementId}/benchmarking`, data);
    return 'success';
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const customerGetOneExperience = async (elementId: string) => {
  try {
    const { data: response } = await axios.get(`/review-1/customers/${elementId}/experience`);
    return response.item;
  } catch (error) {
    console.error(error)
    return 'error';
  }
};

export const customerPutOneExperience = async (elementId: string, data: object) => {
  try {
    await axios.put(`/review-1/customers/${elementId}/experience`, data);
    return 'success';
  } catch (error) {
    console.error(error)
    return 'error';
  }
};
